<template>
  <div class="hello">
    <!-- Transition to upload image -->
    <transition name="fade">
    <div v-if="uploadingImage" class="loading">
        <p>Uploading...</p>
    </div>
    </transition>

    <b-container>

        <form>
            <div class="form-group">
                <input id="image-file-license" type="file" class="form-control-file"  @change="onFileChange"/>
            </div>
        </form>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import axios from 'axios'

export default {    
    props: {
        uploadPreset: {
            type: String,
            required: true
        },
        uploadComplete: {
            type: Function,
            required: false
        },
        fileFormatArray: {
            type: Array,
            required: false
        },
        fileFormatError: {
            type: Function,
            required: false
        },
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {
            selectedFile:'',
            fileExtension:'',
            apiKey: '629997215451183',
            cloudName: 'lo4xxr5lr',
            uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload',
            uploadingImage:false,
            
        }
    },

    methods:{
        //User chose a new file
        onFileChange (event) {
        
            if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
            return;
            }
            this.selectedFile = event.target.files[0]

            const name = event.target.files[0].name;
            const lastDot = name.lastIndexOf('.');

            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);

            //outputfile.value = fileName;
            this.fileExtension = ext;

            //Check file format
            if(this.fileFormatArray&&this.fileFormatArray.length>0){
                if(!this.fileFormatArray.includes(ext.toLowerCase())){
                    console.log("File format error")
                    this.fileFormatError()

                }
            }
            this.uploadFileToCloudinary()

        },
        uploadFileToCloudinary(){
            console.log("Uploading to Cloudinary")
            console.log("Upload URL = ")
            console.log(this.uploadURL)
            console.log("Upload preset = ")
            console.log(this.uploadPreset)
            this.uploadingImage = true
            let data = new FormData();
            var max=999999999999
            var min=111111111111
            var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
            var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            data.append('name', this.currentUser.uid + randomIdString + '.' + this.fileExtension);
            data.append('file', this.selectedFile); 
            data.append('upload_preset', this.uploadPreset);
            
            axios
                .post(this.uploadURL, data)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("Upload success")
                        this.uploadComplete(result.data.secure_url)
                    }
                    else{
                        console.log("URL return error")
                    }
                    this.uploadingImage = false

                })
                .catch((err) => {
                    console.log("Error")
                    console.log(err)
                    this.uploadingImage = false
                }) 
        }, 
    },

    mounted(){
    },
}
</script>

